import { GlobalStyle } from "@/styles/theme/default/default";

// Mapping new color names to old color names
// so when we discard the old theme we don't
// have to change anything the actual code
const colors = {
  caramel: 'black',
  charcoal: 'black',
  french: '#2A5CAF',
  limoncello: '#2A5CAF',
  oatmilk: '#F8F8F8',
  mist: '#D2E0EA',
};

export default {
  id: 'old',
  old: true,
  colors,
  fonts: {
    primary: 'AT Surt',
    secondary: {
      family: 'Burgess',
      weight: 600,
      letterSpacing: 'initial'
    }
  },
  buttons: {
    primary: {
      fontSize: '16px',
      fontWeight: 500,
      letterSpacing: 'inherit',
      backgroundColor: 'black',
      color: 'white',
      borderRadius: 0,
      height: '56px',
      border: '1px solid black',
      disabled: {
        backgroundColor: '#797979',
        color: 'white',
        border: '1px solid #797979',
      },
      hover: {
        backgroundColor: '#333333',
        color: 'white',
        border: '1px solid #333333',
      }
    },
    secondary: {
      backgroundColor: 'transparent',
      color: colors.charcoal,
      border: '1px solid black',
      disabled: {
        backgroundColor: 'white',
        color: '#a3a3a3',
        border: '1px solid #797979',
      },
      hover: {
        backgroundColor: 'transparent',
        color: '#245CAF',
        border: '1px solid #245caf',
      }
    },
    link: {
      color: 'black'
    }
  },
  globalStyles: GlobalStyle
}
